import { defineMessages } from 'react-intl'

export default defineMessages({
  addPatient: {
    id: 'actionBar.addPatient',
    defaultMessage: '+ Add patient'
  },
  visit: {
    id: 'actionBar.visit',
    defaultMessage: 'Visit'
  },
  followUp: {
    id: 'actionBar.followUp',
    defaultMessage: 'Follow Up'
  },
  freeUsageLimitReached: {
    id: 'common.freeUsageLimitReached',
    defaultMessage: 'Free usage limit reached. Contact us to upgrade.'
  }
})
